import { IAPICustomerExtend, ICustomer } from '../ICustomer'

export const customerTransformer = (
  apiCustomer: IAPICustomerExtend,
): ICustomer => ({
  customerUuid: apiCustomer.uuid,
  customerId: apiCustomer.id,
  customerName: apiCustomer.first_name,
  customerLastName: apiCustomer.last_name,
  customerEmail: apiCustomer.email,
  customerAvatar: apiCustomer.image,
  isTopCustomer: apiCustomer.is_top_customer,
  address: apiCustomer.address,
  city: apiCustomer.city,
  zipcode: apiCustomer.zipcode,
  street: apiCustomer.street,
})
